/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS, GET_SECTION_OPTIONS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import config from "../config/analyticsWidget.config.json";
import { templateReplacer } from "../../../helpers/template.replace";
import { pretty } from "@vlinder-web/utils-react";
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
export interface ISalesCostumeInventoryMethods extends IPluginMethodMap {
  getCostume(args: any): Promise<any>;
}
export class SalesCostumeInventoryService implements IAgentPlugin {
  readonly methods: ISalesCostumeInventoryMethods;
  constructor() {
    this.methods = {
      getCostume: this.getCostumeProps.bind(this),
    };
  }
  async getCostumeProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let addOnFilter = {};

    console.log("args in grpah===", args?.criteria);

    const filter = {
      year: {
        eq: "2024",
      },
      status: {
        eq: "active",
      },
    };
    try {
      if (client) {
        const _res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: filter,
          },
          fetchPolicy: "network-only",
        });
        const defaultPresentation =
          _res?.data?.getPresentations?.content[0]?.id;
        if (args?.criteria === "") {
          args.criteria = defaultPresentation;
        }
        addOnFilter = {
          filter: {
            presentation: {
              eq: args?.criteria ?? defaultPresentation,
            },
          },
        };
        const res = await client.query({
          query: GET_SECTION_OPTIONS,
          variables: {
            ...addOnFilter,
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          let formattedData1 = this.formatTable(
            res?.data?.getCostumeTypes?.content
          );
          let formattedConfig = this.getTransformConfig(
            config,
            formattedData1[0]?.result,
            formattedData1[0]?.label
          );
          console.log("foarmatted data is====", pretty(formattedConfig));
          return {
            response: formattedConfig,
            total: formattedData1[0]?.total,
            typeOfSearch: _res?.data?.getPresentations?.content?.map(
              (_item: any) => {
                return { value: _item?.id, label: _item?.name };
              }
            ),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }
  private getTransformConfig(data: any, result?: any[], labels?: any[]) {
    let _data = data.layout[0].colProps[0].compProps.salesValue.day;
    _data.chartSeries = result;
    _data.labels = labels;
    const jsonString = JSON.stringify(data);
    console.log("jsonString 107===>", jsonString);
    return JSON.parse(jsonString);
  }

  private getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };
 
  private formatTable = (data: any[]): any[] => {
    let colors: any[] = [
      "#CC0D4E",
      "#C3D8C4",
      "#F2D0F9",
      "#8268F3",
      "#E2C614",
      "#52473C",
      "#78CFA8",
      "#7658F9",
      "#3FBA8F",
      "#90A765",
      "#E1B655",
      "#681ABD",
      "#15660A",
      "#FEB9D3",
      "#DDE628"]
    const uniqueSections = [...new Set(data.filter
      (item => item.section && item.section.name).map
      (item => item.section.name))];

    const uniqueNames = [...new Set(data.map(item => item.name))];

    const result = uniqueNames.map(name => ({
      name: name,
      data: uniqueSections.map(section => {
        const count = data
          .filter(item => item.name === name &&
            item.section &&
            item.section.name === section)
          .reduce(
            (sum, item) =>
              sum +
              item.inventoryDetail.defaultInvitesUsed +
              item.inventoryDetail.sectionSpecificInvitesUsed +
              item.inventoryDetail.specialInvitesUsed,
            0
          );
        return count;
      }),
    }));
    let colorCount= 0;
    result.forEach(obj => {
      obj.color = colors[colorCount++];
      console.log("color==>", obj.color)
    });
    let total = 0;
    result.forEach((item: any) => {
      let c = 0;
      for (let i = 0; i < item?.data.length; i++) {
        c += item?.data[i];
      }
      total += c;
      item.name = `${item?.name} (${c})`
      console.log("result==>", item?.name, total)
    })
    let resArray: any[] = [];
    resArray.push({ result: result, label: uniqueSections, total: total });
    return resArray;
  };

}


